import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGElement from './SVGElement';

export default class Triangle extends Component {
  static propTypes = {
    className: PropTypes.string,
    direction: PropTypes.oneOf([
      'left',
      'right',
      'back',
      'forward',
      'up',
      'down',
    ]),
    height: PropTypes.string,
    strokeColor: PropTypes.string,
    width: PropTypes.string,
  };

  static defaultProps = {
    direction: 'forward',
    strokeColor: '#979797',
  };

  getRotation = direction => {
    switch (direction) {
      case 'left':
      case 'back':
        return '360';
      case 'down':
        return '270';

      case 'up':
        return '90';
      case 'right':
      case 'forward':
      default:
        return '180';
    }
  };

  render() {
    const { className, direction, height, strokeColor, width } = this.props;

    const rotation = this.getRotation(direction);

    return (
      <SVGElement
        className={className}
        height={height}
        viewBox="0 0 11 18"
        width={width}
      >
        <g stroke="none" strokeWidth="0" fill="none" fillRule="evenodd">
          <g transform="translate(-350.000000, -349.000000)" fill={strokeColor}>
            <polygon
              transform={`
                      translate(356.000000, 358.000000)
                      rotate(${rotation})
                      translate(-356.000000, -358.000000)
                    `}
              points="351 358 361 350 361 366"
            />
          </g>
        </g>
      </SVGElement>
    );
  }
}
